module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/icon5.d29a7f90.png";